// Single source of truth for scroll progress (global 0..1).
export const scrollState = { progress: 0 };

// Adaptive quality (0..1), driven by PerformanceMonitor.
export const perf = { quality: 1 };

export const clamp = (v, a = 0, b = 1) => Math.max(a, Math.min(b, v));
export const smoothstep = (e0, e1, x) => {
  const t = clamp((x - e0) / (e1 - e0), 0, 1);
  return t * t * (3 - 2 * t);
};
export const seg = (p, a, b) => clamp((p - a) / (b - a), 0, 1);
export const band = (p, a, b, c, d) => {
  if (p <= a || p >= d) return 0;
  if (p < b) return smoothstep(a, b, p);
  if (p <= c) return 1;
  return 1 - smoothstep(c, d, p);
};
export const lerp = (a, b, t) => a + (b - a) * t;

// Background stays essentially black throughout (all-black theme).
export const getDarkness = () => 1;

// Gentle camera drift for dust parallax (no 3D objects to plunge through anymore).
export const getCameraZ = (p) => 5.6 - Math.sin(p * Math.PI) * 0.6;
export const getCameraY = (p) => Math.sin(p * Math.PI * 1.4) * 0.25;

export const getCardVisibility = (p) => 1 - smoothstep(0.2, 0.32, p);

// Noise words / extra intensity window (Act 2)
export const getNoiseActivity = (p) => band(p, 0.14, 0.2, 0.43, 0.47);
export const getNoiseStream = (p) => seg(p, 0.14, 0.47);

export const getPhoneReveal = (p) => smoothstep(0.5, 0.6, p);
export const getPhoneDissolve = (p) => smoothstep(0.86, 0.97, p);

export const getPhoneRotation = (p) => {
  const t = seg(p, 0.56, 0.88);
  const steps = 3;
  const s = t * steps;
  const i = Math.floor(Math.min(s, steps - 0.0001));
  const f = s - i;
  const held = f < 0.5 ? 0 : smoothstep(0.5, 1, f);
  // Each stop lands on a FULL turn so the screen always faces the viewer;
  // a complete 360 spin happens between stops.
  return Math.PI * 2 * (i + held);
};

// Which of the 3 product stops is active (0,1,2)
export const getProductStop = (p) => {
  const t = seg(p, 0.56, 0.88);
  return Math.min(2, Math.floor(t * 3));
};

// Five acts: intro, noise, product, promise, calm. Must stay in step with the
// band boundaries in overlays.js and with LABELS in ProgressRail.
export const getActiveAct = (p) => {
  if (p < 0.14) return 0;
  if (p < 0.47) return 1;
  if (p < 0.75) return 2;
  if (p < 0.93) return 3;
  return 4;
};
